<template>
  <div class="employees-table-container">
    <div>
      <div v-if="origen === 'dashboard'" class="table-actions">
        <CustomButton
          text="Solicitar una baja"
          variant="accept"
          :show-icon="true"
          :icon-src="userDownIcon"
          icon-alt="Solicitar una baja"
          @click="showUnsubscribeModal"
        />
      </div>
      <table class="employees-table">
        <thead class="table-header">
          <tr>
            <th v-if="origen !== 'dashboard'">ID MEMBER</th>
            <th>APELLIDO<br />PATERNO</th>
            <th>APELLIDO<br />MATERNO</th>
            <th>NOMBRE(S)</th>
            <th>CORREO<br />ELECTRÓNICO</th>
            <th>TELEFONO</th>
            <th>COBERTURA</th>
            <th>FECHA DE<br />ACTIVACIÓN</th>
            <th>ESTATUS DE<br />LA COBERTURA</th>
            <th v-if="origen !== 'dashboard'">ENVIADO A MEETLIFE</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="isLoadingEmployees">
            <td :colspan="origen !== 'dashboard' ? 10 : 8" class="loading-row">
              <div class="loading-text">Cargando colaboradores...</div>
            </td>
          </tr>
          <tr v-else-if="employees.length === 0">
            <td :colspan="origen !== 'dashboard' ? 10 : 8" class="empty-state">
              <div class="empty-state-text">NO HAY COBERTURAS ACTIVAS</div>
            </td>
          </tr>
          <tr v-else v-for="employee in paginatedEmployees" :key="employee.id">
            <td v-if="origen !== 'dashboard'">
              <a
                v-if="selfserviceBaseUrlNormalized && employee.mutuusId"
                :href="selfserviceBaseUrlNormalized + '/dashboard/solicitud/' + employee.mutuusId"
                target="_blank"
                rel="noopener noreferrer"
                class="id-member-link"
              >
                {{ employee.mutuusId }}
              </a>
              <span v-else>{{ employee.mutuusId }}</span>
            </td>
            <td>{{ employee.paternalLastName }}</td>
            <td>{{ employee.maternalLastName || '-' }}</td>
            <td>{{ employee.names }}</td>
            <td>{{ employee.email }}</td>
            <td>{{ employee.phone || '-' }}</td>
            <td>{{ employee.productName }}</td>
            <td>
              <div
                v-if="
                  employee.membershipStatus === IncorporationStatus.APROBACION ||
                  employee.membershipStatus === 'APROBACIÓN'
                "
                class="empty-cell"
              >
                <span class="empty-text">Pendiente</span>
              </div>
              <span v-else>
                {{
                  employee.activationDate
                    ? new Date(employee.activationDate).toLocaleDateString('es-MX')
                    : '-'
                }}
              </span>
            </td>
            <td>
              <span
                v-if="employee.membershipStatus === MembershipStatusTranslation.VIGENTE"
                class="status-badge status-vigente"
              >
                <InfoButton
                  :messages="[getMembershipStatusMessage(employee.membershipStatus)]"
                  type="Vigente"
                />
                {{ employee.membershipStatus }}
              </span>
              <span
                v-else-if="employee.membershipStatus === 'No emitida'"
                class="status-badge status-no-emitida"
              >
                <img src="@/assets/warning-blue-icon.svg" alt="No emitida" width="16" height="16" />
                {{ employee.membershipStatus }}
              </span>
              <span
                v-else-if="employee.membershipStatus === MembershipStatusTranslation.SUSPENDIDA"
                class="status-badge status-suspendida"
              >
                <InfoButton
                  :messages="[getMembershipStatusMessage(employee.membershipStatus)]"
                  type="Suspendida"
                />
                {{ employee.membershipStatus }}
              </span>
              <span
                v-else-if="employee.membershipStatus === MembershipStatusTranslation.CANCELADA"
                class="status-badge status-cancelada"
              >
                <InfoButton
                  :messages="[getMembershipStatusMessage(employee.membershipStatus)]"
                  type="Cancelada"
                />
                {{ employee.membershipStatus }}
              </span>
              <span
                v-else-if="employee.membershipStatus === MembershipStatusTranslation.COMPLETADA"
                class="status-badge status-completada"
              >
                <InfoButton
                  :messages="[getMembershipStatusMessage(employee.membershipStatus)]"
                  :type="employee.membershipStatus"
                />
                {{ employee.membershipStatus }}
              </span>
              <span
                v-else-if="employee.membershipStatus === MembershipStatusTranslation.APROBACION"
                class="status-badge status-aprobacion"
              >
                <InfoButton
                  :messages="[getMembershipStatusMessage(employee.membershipStatus)]"
                  :type="employee.membershipStatus"
                />
                {{ employee.membershipStatus }}
              </span>
              <span v-else class="status-badge status-default">
                {{ employee.membershipStatus || '-' }}
              </span>
            </td>
            <td v-if="origen !== 'dashboard'">
              <div
                v-if="
                  employee.membershipStatus === MembershipStatusTranslation.APROBACION ||
                  employee.membershipStatus === MembershipStatusTranslation.COMPLETADA
                "
                class="check-icon-cell"
              >
                <input
                  type="checkbox"
                  class="custom-checkbox"
                  :checked="employee.sentMeetlife"
                  @change="toggleSentMeetlife(employee)"
                  :aria-label="
                    employee.sentMeetlife ? 'Enviado a Meetlife' : 'No enviado a Meetlife'
                  "
                />
              </div>
              <div v-else class="empty-cell">
                <img :src="disableCheckedIcon" alt="Check desactivado" width="20" height="20" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <DataPaginator
      v-if="employees.length > 0"
      :total-items="employees.length"
      :current-page="currentPage"
      :items-per-page="itemsPerPage"
      @update:current-page="currentPage = $event"
      @update:items-per-page="itemsPerPage = $event"
      class="table-paginator"
    />

    <ToastMessage
      v-model="showToast"
      :message="toastMessage"
      :submessage="toastSubmessage"
      :duration="10000"
      :type="toastType"
      :icon="toastIcon"
    />

    <div v-if="unsubscribeModalShow" class="custom-modal-overlay">
      <div class="custom-modal">
        <div class="custom-modal-title">Solicitar baja de colaborador</div>
        <div class="custom-modal-content">
          <div>
            <label class="custom-label">Selecciona un Colaborador</label>
            <CustomSelect
              id="membership-type"
              v-model="unsubscribeEmployeeSelected"
              :options="employees"
              :option-value="(option) => option"
              :option-label="
                (option: unknown) => {
                  const emp = option as EmployeeDTO
                  return `${emp.names} ${emp.paternalLastName} ${emp.maternalLastName || ''}`
                }
              "
              placeholder="Selecciona una opción"
              :required="true"
            />
          </div>
          <div v-if="unsubscribeEmployeeSelected" class="member-card">
            <div class="member-card-info member-card-info-flex">
              <div>
                <div style="font-weight: bold">Colaborador seleccionado</div>
                <div style="font-size: medium; font-weight: 600">
                  {{ unsubscribeEmployeeSelected.names }}
                  {{ unsubscribeEmployeeSelected.paternalLastName }}
                  {{ unsubscribeEmployeeSelected.maternalLastName }}
                </div>
                <div style="font-size: small">
                  Email: {{ unsubscribeEmployeeSelected.email }} Teléfono:
                  {{ unsubscribeEmployeeSelected.phone }}
                </div>
              </div>
              <div
                style="
                  margin-left: 24px;
                  min-width: 120px;
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                "
              >
                <span
                  v-if="
                    unsubscribeEmployeeSelected.membershipStatus ===
                    MembershipStatusTranslation.VIGENTE
                  "
                  class="status-badge status-vigente"
                >
                  <InfoButton
                    :messages="[
                      getMembershipStatusMessage(unsubscribeEmployeeSelected.membershipStatus),
                    ]"
                    type="Vigente"
                  />
                  {{ unsubscribeEmployeeSelected.membershipStatus }}
                </span>
                <span
                  v-else-if="unsubscribeEmployeeSelected.membershipStatus === 'No emitida'"
                  class="status-badge status-no-emitida"
                >
                  <img
                    src="@/assets/warning-blue-icon.svg"
                    alt="No emitida"
                    width="16"
                    height="16"
                  />
                  {{ unsubscribeEmployeeSelected.membershipStatus }}
                </span>
                <span
                  v-else-if="
                    unsubscribeEmployeeSelected.membershipStatus ===
                    MembershipStatusTranslation.SUSPENDIDA
                  "
                  class="status-badge status-suspendida"
                >
                  <InfoButton
                    :messages="[
                      getMembershipStatusMessage(unsubscribeEmployeeSelected.membershipStatus),
                    ]"
                    type="Suspendida"
                  />
                  {{ unsubscribeEmployeeSelected.membershipStatus }}
                </span>
                <span
                  v-else-if="
                    unsubscribeEmployeeSelected.membershipStatus ===
                    MembershipStatusTranslation.CANCELADA
                  "
                  class="status-badge status-cancelada"
                >
                  <InfoButton
                    :messages="[
                      getMembershipStatusMessage(unsubscribeEmployeeSelected.membershipStatus),
                    ]"
                    type="Cancelada"
                  />
                  {{ unsubscribeEmployeeSelected.membershipStatus }}
                </span>
                <span
                  v-else-if="
                    unsubscribeEmployeeSelected.membershipStatus ===
                    MembershipStatusTranslation.COMPLETADA
                  "
                  class="status-badge status-completada"
                >
                  <InfoButton
                    :messages="[
                      getMembershipStatusMessage(unsubscribeEmployeeSelected.membershipStatus),
                    ]"
                    :type="unsubscribeEmployeeSelected.membershipStatus"
                  />
                  {{ unsubscribeEmployeeSelected.membershipStatus }}
                </span>
                <span
                  v-else-if="
                    unsubscribeEmployeeSelected.membershipStatus ===
                    MembershipStatusTranslation.APROBACION
                  "
                  class="status-badge status-aprobacion"
                >
                  <InfoButton
                    :messages="[
                      getMembershipStatusMessage(unsubscribeEmployeeSelected.membershipStatus),
                    ]"
                    :type="unsubscribeEmployeeSelected.membershipStatus"
                  />
                  {{ unsubscribeEmployeeSelected.membershipStatus }}
                </span>
                <span v-else class="status-badge status-default">
                  {{ unsubscribeEmployeeSelected.membershipStatus || '-' }}
                </span>
              </div>
            </div>
          </div>
          <div>
            <CustomInput
              id="reason"
              v-model="unsubscribeReason"
              label="Motivo de la baja"
              placeholder="Escribe el motivo de la baja"
              :maxlength="100"
              :required="true"
              required-message="Es necesario ingresar un Motivo de baja para continuar"
              :full-width="true"
              :uppercase="true"
            />
          </div>
        </div>
        <div class="custom-modal-actions">
          <CustomButton text="Cancelar" variant="cancel" @click="unsubscribeModalShow = false" />
          <CustomButton
            text="Solicitar baja"
            variant="accept"
            :disabled="!unsubscribeEmployeeSelected || !unsubscribeReason"
            @click="showUnsubscribeConfirmationModal"
            :show-icon="true"
            :icon-src="userDownIcon"
            icon-alt="Agregar"
            :icon-width="20"
            :icon-height="20"
          />
        </div>
      </div>
    </div>
    <div v-if="unsubscribeModalConfirmationShow" class="custom-modal-overlay">
      <div class="custom-modal">
        <div class="custom-modal-confirmation-title">Solicitar baja de colaborador</div>
        <div class="custom-modal-content">
          <div>
            Para continuar con la baja, es necesario que ingreses el nombre completo del
            colaborador.
            <p>
              Colaborador: {{ unsubscribeEmployeeSelected?.names }}
              {{ unsubscribeEmployeeSelected?.paternalLastName }}
              {{ unsubscribeEmployeeSelected?.maternalLastName }}
            </p>
          </div>
          <div>
            <CustomInput
              id="employee-name"
              v-model="unsubscribeEmployeeName"
              label="Nombre del colaborador"
              placeholder="Escribe el nombre del colaborador"
              :maxlength="100"
              :required="true"
              required-message="Es necesario ingresar un Nombre de colaborador para continuar"
              :full-width="true"
            />
          </div>
        </div>
        <div class="custom-modal-actions">
          <CustomButton
            text="Cancelar"
            variant="cancel"
            @click="unsubscribeModalConfirmationShow = false"
          />
          <CustomButton text="Continuar" variant="accept" @click="sendUnsubscribeRequest" />
        </div>
      </div>
    </div>
    <CustomLoading :is-visible="isLoading" :text="loadingText" />
    <CustomConfirmationModal
      :show="showModalConfirmation"
      title="Marcaste previamente como enviado a Meetlife"
      message="¿Estas seguro que deseas deseleccionar la casilla?"
      accept-label="Si, deseleccionar"
      :sub-message="modalConfirmationSubMessage"
      @accept="handleModalConfirmationAccept(modalConfirmationAction)"
      @cancel="handleModalConfirmationCancel(modalCancellationAction)"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, inject, onMounted, ref } from 'vue'
import DataPaginator from './DataPaginator.vue'
import type { EmployeeDTO } from 'commons'
import { IncorporationStatus, MembershipStatusTranslation } from 'commons'
import userDownIcon from '@/assets/user-down.svg'
import ToastMessage from '../components/ToastMessage.vue'
import checkIcon from '@/assets/check-icon.svg'
import errorIcon from '@/assets/error-icon-white.svg'
import { ApiService } from '../services/apiService'
import CustomSelect from './CustomSelect.vue'
import CustomInput from './CustomInput.vue'
import CustomLoading from './CustomLoading.vue'
import CustomButton from './CustomButton.vue'
import { useBulkLoadStore } from '@/stores/bulkLoad'
import InfoButton from './InfoButton.vue'
import { MEMBERSHIP_STATUS_INFO } from '../utils/constants'
import { trackGroupEvent } from '@/utils/googleAnalyticsEventsSender'
import CustomConfirmationModal from '../components/CustomConfirmationModal.vue'
import disableCheckedIcon from '@/assets/disabled-checked.svg'
import { WebEnvironmentConfigService } from '@/services/env-config.service'

const apiService = inject<ApiService>('apiService')
const envConfig = new WebEnvironmentConfigService()
const selfservicePanelBaseUrl = ref('')

if (!apiService) {
  throw new Error('apiService is not provided')
}

interface Props {
  origen: string
}

defineProps<Props>()

const currentPage = ref(1)
const itemsPerPage = ref(15)
const unsubscribeModalShow = ref(false)
const unsubscribeEmployeeSelected = ref<EmployeeDTO | null>(null)
const unsubscribeReason = ref('')
const unsubscribeModalConfirmationShow = ref(false)
const unsubscribeEmployeeName = ref('')
const showToast = ref(false)
const toastMessage = ref('')
const toastSubmessage = ref('')
const toastType = ref<'success' | 'error'>('success')
const toastIcon = ref<string | undefined>(undefined)
const isLoading = ref(false)
const loadingText = ref('')
const employees = ref<EmployeeDTO[]>([])
const bulkLoadStore = useBulkLoadStore()
const isLoadingEmployees = ref(false)
const showModalConfirmation = ref(false)
const modalConfirmationAction = ref<() => void>(() => {})
const modalCancellationAction = ref<() => void>(() => {})

onMounted(async () => {
  selfservicePanelBaseUrl.value = await envConfig.getSelfservicePanelBaseUrl()
  await fetchEmployees()
})

const selfserviceBaseUrlNormalized = computed(() =>
  (selfservicePanelBaseUrl.value || '').replace(/\/$/, ''),
)

const paginatedEmployees = computed(() => {
  if (!employees.value || employees.value.length === 0) return []
  const start = (currentPage.value - 1) * itemsPerPage.value
  const end = start + itemsPerPage.value
  return employees.value.slice(start, end)
})

const showUnsubscribeModal = () => {
  unsubscribeModalShow.value = true
  unsubscribeEmployeeSelected.value = null
  unsubscribeReason.value = ''
}

const showUnsubscribeConfirmationModal = () => {
  unsubscribeModalShow.value = false
  unsubscribeModalConfirmationShow.value = true
  unsubscribeEmployeeName.value = ''
}

const sendUnsubscribeRequest = async () => {
  if (
    unsubscribeEmployeeName.value !==
    unsubscribeEmployeeSelected.value?.names +
      ' ' +
      unsubscribeEmployeeSelected.value?.paternalLastName +
      ' ' +
      (unsubscribeEmployeeSelected.value?.maternalLastName || '')
  ) {
    showToast.value = true
    toastMessage.value = 'Inconsistencia'
    toastSubmessage.value = 'El nombre ingresado no coincide con el colaborador seleccionado.'
    toastType.value = 'error'
    toastIcon.value = errorIcon
    return
  }
  try {
    trackGroupEvent('unsubscribe_member_request', {
      location: 'Dashboard',
      company_name: bulkLoadStore.selectedGroup?.nombrePublico || '',
    })
    isLoading.value = true
    loadingText.value = 'Enviando solicitud...'
    await apiService.sendUnsubscribeRequest(
      unsubscribeEmployeeSelected!.value!.id!,
      unsubscribeReason.value,
    )
    showToast.value = true
    toastMessage.value = 'Solicitud exitosa'
    toastSubmessage.value = 'La baja se verá reflejada en un máximo de 24 horas.'
    toastType.value = 'success'
    toastIcon.value = checkIcon
    unsubscribeModalConfirmationShow.value = false
  } catch {
    showToast.value = true
    toastMessage.value = 'Error'
    toastSubmessage.value = 'Ocurrió un error al enviar la solicitud de baja. Inténtalo de nuevo.'
    toastType.value = 'error'
    toastIcon.value = errorIcon
  } finally {
    isLoading.value = false
  }
}

const fetchEmployees = async () => {
  try {
    isLoadingEmployees.value = true
    if (bulkLoadStore.selectedGroup?.id) {
      const employeesData = await apiService.getEmployeesByGroup(
        bulkLoadStore.selectedGroup.id,
        true,
      )
      employees.value = employeesData
    }
  } catch {
    // Aqui se captura el error pero no se hace nada con el ya que el error es por que no encuentra la compania
  } finally {
    isLoadingEmployees.value = false
  }
}

const getMembershipStatusMessage = (status?: string): string => {
  if (!status) return ''
  if (status === MembershipStatusTranslation.VIGENTE) {
    return MEMBERSHIP_STATUS_INFO[MembershipStatusTranslation.VIGENTE]
  }
  if (status === MembershipStatusTranslation.SUSPENDIDA) {
    return MEMBERSHIP_STATUS_INFO[MembershipStatusTranslation.SUSPENDIDA]
  }
  if (status === MembershipStatusTranslation.CANCELADA) {
    return MEMBERSHIP_STATUS_INFO[MembershipStatusTranslation.CANCELADA]
  }
  if (status === MembershipStatusTranslation.COMPLETADA) {
    return MEMBERSHIP_STATUS_INFO[MembershipStatusTranslation.COMPLETADA]
  }
  if (status === MembershipStatusTranslation.APROBACION) {
    return MEMBERSHIP_STATUS_INFO[MembershipStatusTranslation.APROBACION]
  }
  return ''
}

function handleModalConfirmationAccept(action: () => void) {
  showModalConfirmation.value = false
  action()
}

function handleModalConfirmationCancel(action: () => void) {
  showModalConfirmation.value = false
  action()
}

// Acción para el checkbox de enviado a Meetlife
const toggleSentMeetlife = async (employee: EmployeeDTO) => {
  if (employee.sentMeetlife) {
    // Si ya está marcado, mostrar el modal de confirmación
    modalConfirmationAction.value = () => updateSentMeetlife(employee)
    modalCancellationAction.value = () => cancelUpdateSentMeetlife()
    showModalConfirmation.value = true
  } else {
    // Si no está marcado, actualizar directamente
    await updateSentMeetlife(employee)
  }
}

const updateSentMeetlife = async (employee: EmployeeDTO) => {
  try {
    employee.sentMeetlife = !employee.sentMeetlife
    await apiService.updateEmployeeSentToMeetlife(employee.id!, employee.sentMeetlife)
    fetchEmployees() // Refrescar la lista de empleados
  } catch (error) {
    console.error('Error al actualizar el estado de Enviado a Meetlife:', error)
  }
}

const cancelUpdateSentMeetlife = () => {
  // Revertir el cambio en el checkbox
  fetchEmployees() // Refrescar la lista de empleados
  showModalConfirmation.value = false
}
</script>

<style scoped>
/* Custom Employees Table Styles */
.employees-table-container {
  width: 100%;
  margin: 0 auto;
  overflow-x: auto;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 40px;
  position: relative;
  min-height: 400px;
}

.button-section {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.employees-table {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
  table-layout: fixed;
}

/* Table Paginator Alignment */
.table-paginator {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  padding: 0;
}

.table-paginator :deep(.data-paginator) {
  width: 100%;
  justify-content: flex-end;
  padding: 1rem 0;
  margin-top: 1rem;
  border-top: 1px solid #e0e0e0;
}

.employees-table th,
.employees-table td {
  border: 1px solid #ccc;
  padding: 0.5rem;
  text-align: center;
  line-height: 1.2;
  border-collapse: collapse;
  box-sizing: border-box;
  white-space: normal;
  word-wrap: break-word;
}

.employees-table th {
  background: #003896;
  color: #fff;
  text-transform: uppercase;
}

.id-member-link {
  color: #003896;
  text-decoration: underline;
}

.id-member-link:hover {
  text-decoration: none;
}

.employees-table tbody tr:nth-child(even) {
  background-color: #f2f5f9;
}

.employees-table tbody tr:nth-child(odd) {
  background-color: #ffffff;
}

.employees-table th:nth-child(1),
.employees-table td:nth-child(1) {
  width: 10%; /* Apellido Paterno */
}

.employees-table th:nth-child(2),
.employees-table td:nth-child(2) {
  width: 10%; /* Apellido Materno */
}

.employees-table th:nth-child(3),
.employees-table td:nth-child(3) {
  width: 12%; /* Nombre(s) */
}

.employees-table th:nth-child(4),
.employees-table td:nth-child(4) {
  width: 13%; /* Correo Electronico */
}

.employees-table th:nth-child(5),
.employees-table td:nth-child(5) {
  width: 13%; /* Telefono */
}

.employees-table th:nth-child(6),
.employees-table td:nth-child(6) {
  width: 8%; /* Membresía */
}

.employees-table th:nth-child(7),
.employees-table td:nth-child(7) {
  width: 8%; /* Fecha de Activación */
}

.employees-table th:nth-child(8),
.employees-table td:nth-child(8) {
  width: 12%; /* Estado de Membresía */
}

.employees-table th:nth-child(9),
.employees-table td:nth-child(9) {
  width: 8%; /* Enviado a Meetlife */
}

/* Status badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4em;
  border-radius: 24px;
  font-size: 0.6rem;
  font-weight: 800;
  padding: 4px 12px;
  border: 1px solid;
  width: fit-content;
  height: 25px;
  text-align: center;
}

.status-vigente {
  background: #aed491;
  color: #3f7623;
  border-color: #3f7623;
}

.status-no-emitida {
  background: #91c9ff;
  color: #003ea7;
  border-color: #003ea7;
}

.status-suspendida {
  background: #fff3b7;
  color: #916c29;
  border-color: #916c29;
}

.status-cancelada {
  background: #ffada9;
  color: #a83535;
  border-color: #a83535;
}

.status-aprobacion {
  background: #0059ef;
  color: #fafafa;
  border-color: #003896;
}

.status-completada {
  background: #91c9ff;
  color: #003ea7;
  border-color: #76aeff;
}

.status-default {
  background: #f5f5f5;
  color: #666666;
  border-color: #666666;
}

.table-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.table-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  width: 200px;
  height: 48px;
  border-radius: 30px;
}
.table-btn.cancel {
  background: #e0e0e0; /* Inside auto layout */

  color: #333;
}
.table-btn.accept {
  background: #d0342c;
  color: #fff;
}
.member-card {
  justify-content: space-between;
  align-items: center;
  padding: 16px 36px;
  background: #ffffff;
  border: 1px solid #a1a1a1;
  border-radius: 16px;
  flex-grow: 0;
}
.member-card-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.member-card-info-flex {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

/* Checkbox personalizado para ENVIADO A MEETLIFE */
.check-icon-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-checkbox {
  appearance: none;
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid #bdbdbd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
  position: relative;
}
.custom-checkbox:checked {
  background: #8dd22a;
  border-color: #8dd22a;
}
.custom-checkbox:checked::after {
  content: '';
  display: block;
  width: 11px;
  height: 7px;
  border-left: 3px solid #fff;
  border-bottom: 3px solid #fff;
  position: absolute;
  left: 3px;
  top: 3px;
  transform: rotate(-45deg);
}
.custom-checkbox:focus {
  outline: none;
  box-shadow: 0 0 0 2px #8dd22a44;
}
</style>
